class ReferralFormController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        $scope.selectedUsers = localStorageService.get('selectedUsers')
        $scope.referal = {}
        authService.callAPI(MEDICALCONSTANT.API_GET_MEDICINE_LIST + schoolId, "GET", {}, (response) => {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0)
                    $scope.medicineList = response.result.data.data
                _.defer(function() {
                    $scope.$apply();
                });
            }
        })
        $scope.selectedMedicine = (medicineName) => {
            $scope.batchIds = []
            _.each($scope.medicineList, function(eachPdt) {
                if (eachPdt.medicine_name === medicineName) {
                    $scope.batchIds.push({
                        'batch_no': eachPdt.batch_no,
                        'exp_date': eachPdt.exp_date
                    })

                }
            })
            $scope.batchIds.sort(function(a, b) {
                var nameA = a.exp_date
                var nameB = b.exp_date
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        }
        $scope.expDateError = null
        $scope.selectedBatchId = (batchId) => {
            if ($scope.batchIds[0].batch_no !== batchId)
                $scope.expDateError = "Please select first batchId in the list having least expiry date"
            else
                $scope.expDateError = null

            $scope.quantity = []
            _.each($scope.medicineList, function(eachPdt) {
                if (eachPdt.batch_no === batchId) {
                    if (eachPdt.remaining_count > 0) {

                        for (var i = 1; i <= eachPdt.remaining_count; i++) {
                            $scope.quantity.push(i);
                        }
                    }
                }

            })
        }
        if ($stateParams.studentId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
            $scope.isEdit = true
            $scope.referal.date = $stateParams.data.date_incident_occured
            $scope.referal.time = $stateParams.data.time_incident_occured
            $scope.referal.injury_type = $stateParams.data.injury_type
            $scope.referal.from_exercise_session = $stateParams.data.absence_day[0].from_exercise_session
            $scope.referal.from_school = $stateParams.data.absence_day[0].from_school
            $scope.referal.injury_cause = $stateParams.data.injury_cause
            $scope.referal.injury_level = $stateParams.data.injury_level
            $scope.referal.blood_group = $stateParams.data.blood_group
            $scope.referal.injured_part_body = $stateParams.data.injured_part_body
        }
        $scope.saveReferalForm = () => {
            $scope.errors = {}
            let errorCount = 0
            var obj = {
                date: ($scope.referal.date) ? $scope.referal.date : null,
                time: ($scope.referal.time) ? $scope.referal.time : null,
                injury_type: ($scope.referal.injury_type) ? $scope.referal.injury_type : null,
                injured_body_part: ($scope.referal.injured_body_part) ? $scope.referal.injured_body_part : null,
                injury_level: ($scope.referal.injury_level) ? $scope.referal.injury_level : null,
                injury_cause: ($scope.referal.injury_cause) ? $scope.referal.injury_cause : null,
                from_exercise_session: ($scope.referal.from_exercise_session) ? $scope.referal.from_exercise_session : null,
                from_school: ($scope.referal.from_school) ? $scope.referal.from_school : null,
                accident_location: ($scope.referal.accident_location) ? $scope.referal.accident_location : null,
                medicine: ($scope.referal.medicine) ? $scope.referal.medicine : null,
                batch_id: ($scope.referal.batch_id) ? $scope.referal.batch_id : null,
                quantity: ($scope.referal.quantity) ? $scope.referal.quantity : null,
                follow_up: ($scope.referal.follow_up) ? $scope.referal.follow_up : null,
                selected_users: $scope.selectedUsers,
                user_id: userId
            }
            if (errorCount === 0) {
                if ($stateParams.is_edit === true && $stateParams.data !== true) {
                    /* Meteor.call("editReferalIncident", obj, $scope.selectUser, $stateParams.data._id, function(error, result) {
                         if (error) { // if it fails, show error message
                             toastr.error(error.reason);
                             return;
                         } else {
                             $scope.errors = {}
                             toastr.success("Successfully edited");
                             $state.go("medicalUserProfile", {
                                 userId: $scope.selectUser
                             })
                         }
                     })*/
                } else {
                    if ($scope.expDateError === null) {
                        authService.callAPI(MEDICALCONSTANT.API_SAVE_REFERRAL_FORM, "POST", obj, (response) => {
                            if (response.result && response.result.data && response.result.data.data) {
                                $state.go("userProfile")
                            }
                        })
                    }
                }
            }
        }
    }
}
export default ReferralFormController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/incidents/createReferralForm.js